import React, { useState } from 'react';
import './App.css';
import logo from './logo.png';

const WORKER_URL = 'https://tonus-events.ehorta.workers.dev/worker-sites/api/interest';
// Einfache Email-Regex: muss ein „@“ und einen Punkt im Domain-Teil haben
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function App() {
  const [response, setResponse] = useState(null);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState('');

  // Speichert Interesse/Email in KV
  const saveInterest = async (emailToSave = '') => {
    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailToSave })
      });
      if (!res.ok) {
        console.error('Failed to save interest:', await res.text());
      }
    } catch (err) {
      console.error('Error sending interest to worker:', err);
    }
  };

  const handleInterested = async () => {
    // 1) sofort Interest-Log (ohne email)
    await saveInterest('');
    // 2) öffne Modal zur Email-Eingabe
    setResponse('interested');
  };

  const handleNotInterested = () => {
    setResponse('not-interested');
  };

  const submitEmail = async () => {
    // Leere Eingabe heisst „kein Email gewünscht“
    if (!email) {
      setSubmitted(true);
      return;
    }
    // Validierung
    if (!EMAIL_REGEX.test(email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }
    // Valid: Email speichern und Modal-Status updaten
    setEmailError('');
    await saveInterest(email);
    setSubmitted(true);
  };

  const closeModal = () => {
    setResponse(null);
    setEmail('');
    setSubmitted(false);
    setEmailError('');
  };

  return (
    <div className="app">
      <header>
        <img src={logo} alt="TONUS Logo" />
        <h1>TONUS Events</h1>
      </header>

      <main className="container">
        <div className="event-box">
          <h2>TONUS Info Event</h2>
          <div className="event-details">
            <div className="left">
              <p><strong>Location:</strong> ETH HG D7.2</p>
              <p><strong>Time:</strong> May 27, 2025 at 10:15 AM</p>
            </div>
            <div className="right">
              <h3>Program</h3>
              <ul>
                <li>Presentation</li>
                <li>Open Q&A</li>
                <li>Reception</li>
              </ul>
            </div>
          </div>

          <div className="interest-buttons left-align">
            <button onClick={handleInterested} className="btn positive">
              <span role="img" aria-label="Thumbs up">👍</span> I'm interested
            </button>
            <button onClick={handleNotInterested} className="btn negative">
              <span role="img" aria-label="Thumbs down">👎</span> I'm not interested
            </button>
          </div>
        </div>

        <div className="cta">
          <a href="https://tonus.dev" target="_blank" rel="noopener noreferrer">
            Learn more about TONUS
          </a>
          <a href="https://application.tonus.dev" target="_blank" rel="noopener noreferrer">
            Apply now
          </a>
        </div>
      </main>

      <footer>&copy; 2025 TONUS</footer>

      {response === 'interested' && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>Thank you for your interest!</h4>
            {!submitted ? (
              <div className="email-collect">
                <label>
                  Leave your email for updates (optional):
                  <input
                    type="email"
                    value={email}
                    onChange={e => {
                      setEmail(e.target.value);
                      setEmailError('');
                    }}
                    placeholder="you@example.com"
                  />
                </label>
                {emailError && <p className="error">{emailError}</p>}
                <button onClick={submitEmail} className="btn submit-btn" disabled={!!email && !EMAIL_REGEX.test(email)}>
                  Submit
                </button>
              </div>
            ) : (
              <p>
                {email ? ' Your email has been saved.' : '.'}
              </p>
            )}
            <button onClick={closeModal} className="btn close-btn">Close</button>
          </div>
        </div>
      )}

      {response === 'not-interested' && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>That's a pity.</h4>
            <button onClick={closeModal} className="btn close-btn">Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
